// extracted by mini-css-extract-plugin
module.exports = {"outOfStock":"DDgM4"};